'use client';

import { useInView } from '@/lib/useInView';

interface SingleVideoProps {
  videoUrl: string;
  className?: string;
}

export default function SingleVideo({ 
  videoUrl, 
  className = "" 
}: SingleVideoProps) {
  const { ref } = useInView<HTMLDivElement>();

  if (!videoUrl) return null;

  return (
    <div ref={ref} className={`animate-in-view full-bleed ${className}`}>
      {videoUrl.includes('vimeo.com') ? (
        <div className="relative w-full h-0 pb-[56.25%] rounded-lg overflow-hidden">
          <iframe
            src={`https://player.vimeo.com/video/${videoUrl.split('/').pop()?.split('?')[0]}?autoplay=1&muted=1&loop=1&controls=0`}
            className="absolute top-0 left-0 w-full h-full"
            frameBorder="0"
            allow="autoplay; fullscreen; picture-in-picture"
            allowFullScreen
          />
        </div>
      ) : (
        <video 
          src={videoUrl} 
          autoPlay 
          muted 
          loop 
          playsInline
          controls={false}
          className="w-full h-auto  object-cover rounded-lg"
        />
      )}
    </div>
  );
}
